module.exports = __webpack_public_path__ + "static/media/progress.a48dc3c1.jpg";